import { css } from 'styled-components'

/**
 * Shared table styling for the Device Access Control flows, extracted from the
 * CM-2888 Figma (`.device_table`, node 1:5498) so the devices / manage-device /
 * sign-ins tables all match the design:
 *  - grey header row (`Fill/Darker` #e9ecef, `Secondary text` #595959, 14px)
 *  - zebra rows (odd = `Fill/Subtle` #fafafa, even = white) with #f0f0f0 dividers
 *  - 16px (`radius-md`) container radius
 */
export const cssDeviceTable = css`
  .ant-table {
    border-radius: 16px;
  }

  .ant-table-thead > tr > th {
    background-color: #e9ecef;
    color: #595959;
    font-size: 14px;
    line-height: 16px;
    font-weight: 500;
    border-bottom: none;
  }

  .ant-table-tbody > tr > td {
    border-bottom: 1px solid #f0f0f0;
    color: #333333;
    font-size: 16px;
    line-height: 24px;
  }

  .ant-table-tbody > tr:nth-child(odd) > td {
    background-color: #fafafa;
  }

  .ant-table-tbody > tr:nth-child(even) > td {
    background-color: #ffffff;
  }

  /* Rows aren't clickable in any of the device tables (row actions live in the
     action column / three-dot menu), so keep the default arrow cursor. */
  .ant-table-row {
    cursor: default;
  }

  .ant-table-thead > tr > th:first-child { 
    border-start-start-radius: 0 !important; 
  }

  .ant-table-thead > tr > th:last-child  { 
    border-start-end-radius: 0 !important; 
  }
`
